galleryFieldsDirective = angular.module('galleryfields.setting', [])

galleryFieldsDirective.directive "galleryFieldsSetting", ["$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "Widget", "blockEditDialog", "Restangular", ($window, $timeout, $compile, $templateCache, ns, translitService, Widget, blockEditDialog, Restangular) ->
  restrict: "A",
  scope: {data: "=ngModel"},
  templateUrl: "#{settingFolder}/galleryfields/template.jade"
  link: (scope, element, attrs, ngModel) ->
    id = attrs.widgetId
    widgetElWrapper = angular.element("[data-block-id=#{id}]").find ns.widgetWrapperClass
    scope.gallery = angular.copy scope.data

    sectionId = blockEditDialog.getSectionId id:id
    # Widget.getWidget(sectionId, id).then (data) ->
    #   scope.gallery = data

    widgetElWrapper.find("a").click (e) ->
      e.preventDefault()

    getNotDestroyedFieldRnd = ->
      fields = []
      _.each scope.gallery.photos_attributes, (field, index) ->
        if !field._destroy
          fields.push index
      if fields.length > 0
        fields[fields.length-1]
      else
        0

    scope.currentField = getNotDestroyedFieldRnd()

    trimNbsp = (fields) ->
      for field in fields
        field.caption = field.caption.replace(/&nbsp;/gi,'')
      fields

    scope.fieldsLength = (fields) ->
      destroyed = _.filter fields, _destroy: true
      fields.length - destroyed.length

    scope.setCurrentImage = ($index) ->
      scope.currentField = $index

    scope.add = ->
      sectionId = blockEditDialog.getSectionId id:id
      params =
        photos_attributes: [{remote_file_url: "#{Restangular.configuration.baseUrl}/assets/widgets/gallery/img4.jpg"}]
      Widget.createItem(sectionId, id, params).then (data) ->
        newImage = data.photos_attributes[data.photos_attributes.length-1]
        scope.gallery.photos_attributes.push newImage
        length = scope.gallery.photos_attributes.length
        newImageHTML = "
          <li data-lightbox-id='#{newImage.id}'>
              <a href='javascript:void(0)'>
                  <div class='background-image-holder fadeIn' style='background: url(#{newImage.file_url});'>
                      <img alt='image' class='background-image' src='#{newImage.file_url}' style='display: none;'>
                  </div>
              </a>
          </li>"
        widgetElWrapper.find("ul").append newImageHTML
        scope.setCurrentImage length - 1

    removeCurrentImage = ->
      imageId = scope.gallery.photos_attributes[scope.currentField].id
      index = $("[data-lightbox-id='#{imageId}']").remove()

    scope.remove = ->
      scope.gallery.photos_attributes[scope.currentField]._destroy = true
      removeCurrentImage()
      scope.setCurrentImage getNotDestroyedFieldRnd()

    listener1 = scope.$watch "gallery.photos_attributes", (newVal, oldVal) ->
      scope.data.photos_attributes = trimNbsp newVal
    , true

    listener2 = scope.$watch "data", (newVal, oldVal) ->
      renderPhotos newVal
    , true

    scope.$on "$destroy", ->
      listener1()
      listener2()

    renderPhotos = (newVal) ->
      _.each newVal.photos_attributes, (photo) ->
        $("[data-lightbox-id='#{photo.id}']").find(".background-image-holder").css "background", "url('#{photo.file_url}')"

]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/galleryfields/galleryfields.directive.coffee